import React from 'react';

import generalIcons, { GENERAL_ICONS } from 'src/components/svg/general/index';
import analyseIcons from 'src/components/svg/analyse/index';
import menuIcons from 'src/components/svg/menu/index';
import chatIcons from 'src/components/svg/chat/index';
import doctorIcons, { DOCTOR_ICONS } from 'src/components/svg/doctor/index';
import appointmentIcons from 'src/components/svg/appointment/index';
import statsIcons from 'src/components/svg/stats/index';
import adminIcons from 'src/components/svg/admin/index';
import categoryIcons from 'src/components/svg/catagory/index';
import journeyIcons from 'src/components/svg/journey/index';
import { SVGBaseIcon, BASE_ICONS } from './icons';

const list = [
  generalIcons,
  menuIcons,
  analyseIcons,
  chatIcons,
  doctorIcons,
  appointmentIcons,
  statsIcons,
  adminIcons,
  categoryIcons,
  journeyIcons
];

const icons = {};
for (let i in list) {
  for (let icon_name in list[i]) {
    if (!Object.prototype.hasOwnProperty.call(icons, icon_name)) {
      icons[icon_name] = list[i][icon_name];
    } else {
      throw new Error(icon_name + ' icon name is exist.');
    }
  }
}

const getPath = (iconname, props) => {
  const baseIcon = SVGBaseIcon({ iconname, ...props });

  if (baseIcon) return baseIcon;

  if (!icons[iconname]) {
    return null;
  }
  const ComponentIcon = icons[iconname];
  return <ComponentIcon {...props} />;
};
const SVGIcon = React.memo(({ iconname = '', ...props }) => <>{getPath(iconname, { ...props })}</>);
SVGIcon.displayName = 'SVGIcon';

export default SVGIcon;

export { GENERAL_ICONS, BASE_ICONS, DOCTOR_ICONS };
